import React from 'react';

// A labelled number with an optional icon, footnote and progress bar
// (FECOA-2174). Use `bare` inside a container that already draws the card.
const StatCard = ({
  label,
  value,
  hint,
  icon: Icon,
  progress,
  progressLabel,
  children,
  bare = false,
  className = '',
}) => {
  const percent = typeof progress === 'number' ? Math.max(0, Math.min(100, progress)) : null;
  return (
    <div className={`${bare ? '' : 'card'} p-5 ${className}`}>
      <div className="flex items-center justify-between gap-3">
        <p className="text-[13px] font-medium text-gray-500 dark:text-gray-400">{label}</p>
        {Icon && <Icon className="h-4 w-4 flex-shrink-0 text-gray-400 dark:text-gray-500" strokeWidth={1.75} aria-hidden="true" />}
      </div>
      <p className="mt-2 text-[28px] font-semibold leading-none tracking-tight tabular-nums text-gray-900 dark:text-gray-50">{value}</p>
      {hint && <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">{hint}</p>}
      {percent !== null && (
        <div
          className="mt-3 h-1.5 overflow-hidden rounded-full bg-gray-100 dark:bg-white/[0.08]"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(percent)}
          aria-label={progressLabel || label}
        >
          <div className="h-full rounded-full bg-primary-500 transition-[width] duration-700 ease-out" style={{ width: `${percent}%` }} />
        </div>
      )}
      {children}
    </div>
  );
};

export default StatCard;
